const FX = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    color="inherit"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.071 12a8.694 8.694 0 1 1 17.389 0A8.694 8.694 0 0 1 3.07 12zm8.695-9.694C6.412 2.306 2.07 6.646 2.07 12c0 5.354 4.34 9.694 9.695 9.694 5.353 0 9.694-4.34 9.694-9.694 0-5.354-4.34-9.694-9.694-9.694zm-4.51 9.768v3.057h-.41V8.869h3.578v.403H7.256v2.408H9.99v.394H7.256zm6.731.202-2.104 2.855h-.565l2.387-3.197-2.28-3.065H12l2.016 2.732h.02l1.957-2.732h.565l-2.24 3.074 2.367 3.188h-.575l-2.103-2.855h-.02z"
    />
  </svg>
);

export default FX;
